import { useState, useEffect } from "react";
import UserApi from "api/userApi";
import { useAuth } from "auth-context/auth.context";

const useUserRoles = () => {
  const { user: authUser } = useAuth();
  const [user, setUser] = useState(null);
  const [roles, setRoles] = useState({
    isAdmin: false,
    isInvitado: false,
    isAsesorExterno: false,
    isAsesorInterno: false,
    isAsistente: false,
    isOperador: false,
    isCartera: false,
    isCoordinador: false,
    isDirector: false,
  });

  useEffect(() => {
    const fetchUserData = async () => {
      const localUser = localStorage.getItem("user");
      if (!localUser) return;
      try {
        const parsedUser = JSON.parse(localUser);
        // Verificar roles basados en el usuario del localStorage
        const userRoles = {
          isAdmin: parsedUser?.roles?.includes("ADMIN"),
          isInvitado: parsedUser?.roles?.includes("INVITADO"),
          isAsesorExterno: parsedUser?.roles?.includes("ASESOR(A) EXTERNO"),
          isAsesorInterno: parsedUser?.roles?.includes("ASESOR(A) INTERNO"),
          isAsistente: parsedUser?.roles?.includes("ASISTENTE"),
          isOperador: parsedUser?.roles?.includes("OPERADOR(A)"),
          isCartera: parsedUser?.roles?.includes("CARTERA"),
          isCoordinador: parsedUser?.roles?.includes("COORDINADOR(A)"),
          isDirector: parsedUser?.roles?.includes("DIRECTOR(A)"),
          isNotificador: parsedUser?.roles?.includes("NOTIFICADORES"),
        };
        setRoles(userRoles);
        // Solo hacer la petición si tenemos identificación y no tenemos los datos del usuario
        if (parsedUser.identificacion && !user) {
          const response = await UserApi.fetchUser(parsedUser.identificacion);
          if (response.data) {
            setUser(response.data);
          }
        }
      } catch (error) {
        console.error("Error al obtener los datos del usuario:", error);
      }
    };

    fetchUserData();
  }, [user, authUser]); // Agregamos authUser como dependencia

  return { user: user || authUser, roles };
};

export default useUserRoles;
